
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { withdrawInfo, coinTransfer, flashexchange } from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
address: "",
userMoney: [],
showAlert: false,
num: "",
actions: [{ name: this.$t("加密货币"), value: "coin" }, { name: this.$t("外汇"), value: "wh" }, { name: this.$t("美股"), value: "mg" }],  //选择提币的币种列表
type: "",
coin1: this.$t("加密货币"), //选中提的币种
coin2: this.$t("外汇"),
showSymbol: false, //底部选择币种弹出框的展示隐藏
coinListInfo: {},
coin_v1: 'coin',
coin_v2: 'wh',

}
},
components:{
XHeader,
Toast
},
created(){
this.SETTOKEN()
this.getData()

},
computed:{
...mapState([ 'token'])
},
methods:{
...mapMutations(['SETTOKEN']),

getData(){
var that = this
this.$Loading()
withdrawInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1' || res.status=='0'){
that.coinListInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
change(){
const coina = this.coin1
const coinb = this.coin2
this.coin1 = coinb
this.coin2 = coina
},

clearTimer() { //清楚定时器

clearInterval(this.timerInfo)
this.timerInfo = null
},
save(){
if(this.num==''){
this.sendMsg(this.$t("请输入转换数量"))
return
}
var type = 1
console.log(this.coin_v1)
console.log(this.coin_v2)
if(this.coin_v1 == 'coin' && this.coin_v2 == 'mg'){
type = 2
}
if(this.coin_v1 == 'wh' && this.coin_v2 == 'coin'){
type = 3
}
if(this.coin_v1 == 'mg' && this.coin_v2 == 'coin'){
type = 4
}
if(this.coin_v1 == 'mg' && this.coin_v2 == 'wh'){
type = 5
}
if(this.coin_v1 == 'wh' && this.coin_v2 == 'mg'){
type = 6
}
var that = this
this.$Loading()
flashexchange({token: this.token, type, number: this.num, uid: window.localStorage.getItem("uid")}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){


}
})
}else if(res.status=='-1'){
that.$router.push('/pages/login')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
showModal(){
if(this.fromnumber==''){
this.sendMsg(this.$t("请输入转换数量"))
return
}
this.showAlert = true

},
onSelect(item) {
this.showSymbol = false;
if(this.type==1){
this.coin1 = item.name;
this.coin_v1 = item.value
}else{
this.coin2 = item.name;
this.coin_v2 = item.value
}
},
onClose(){

},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},
async pastCont() {
this.address = await navigator.clipboard.readText();
},

sendMsg(content) {
this.msg = content;
this.show = true;
}
},
watch: {

},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
}



// WEBPACK FOOTER //
// ./src/pages/transfer.vue